import React from "react";
import { Link } from "react-router-dom";

const QueryButton = ({
  children = "Contact Us",
}) => {
  return (
    <Link
      to="/contact"
      className="query-button"
    >
      {children}
    </Link>
  );
};

export default QueryButton;
